export enum ClientPaymentMethod {
  BILL_OUT = 'Bill Out'
}
